// eslint-disable-next-line import/prefer-default-export
export function TaskQueue(timeout) {
  this.tasks = [];
  const self = this;
  self.runner = null;
  function enqueue(args) {
    if (self.tasks.length === 0) {
      self.runner = window.setTimeout(() => {
        self.next();
      }, timeout);
    }
    return new Promise(((resolve) => {
      self.tasks.push({ func: resolve, args });
    }));
  }
  function next() {
    self.runner = null;
    if (self.tasks.length > 0) {
      const t = self.tasks.shift();
      t.func(t.args);
      self.runner = window.setTimeout(() => {
        self.next();
      }, timeout);
    }
  }
  function cancel() {
    if (self.runner) {
      clearTimeout(self.runner);
    }
    self.tasks.length = 0;
    self.enqueue().then(() => null);
  }

  self.enqueue = enqueue;
  self.next = next;
  self.cancel = cancel;
  return self;
}

export function AxiosCaller() {
  function Wrapper(promise) {
    const self = this;
    self.promise = promise;
    self.cancelled = false;
    function cancel() {
      self.cancelled = true;
    }
    self.cancel = cancel;
    return {
      prom: new Promise((resolve, reject) => {
        promise.then((val) => {
          if (!self.cancelled) resolve(val);
        });
        promise.catch((err) => {
          if (!self.cancelled) reject(err);
        });
      }),
      cancel: self.cancel,
    };
  }
  const promiseMap = {};
  function Call(name, promise) {
    if (promiseMap[name]) {
      promiseMap[name].cancel();
    }
    promiseMap[name] = new Wrapper(promise);
    return promiseMap[name].prom;
  }
  function CancelRequest(name) {
    if (promiseMap[name]) {
      promiseMap[name].cancel();
    }
  }
  this.Call = Call;
  this.CancelRequest = CancelRequest;
  return this;
}
